import type { ProcessArgs } from "./parser";
import * as cheerio from "cheerio";

export function wrapInnerLink(
  element: cheerio.Element,
  args: ProcessArgs,
): void {
  const { content, references } = args;
  const $ = cheerio.load(content);

  const postId = $(element).text();
  const parent = $(element).parent();
  const ref = references.find((ref) => ref.postId === postId);

  if (!ref) return;

  $(
    parent,
  ).replaceWith(`<a class="border border-primary card my-2 scale-90 shadow-md" href="/posts/${postId}/">
  <figure><img src="${ref.eyecatch?.url}" alt="Hero" class="object-fill"/></figure>
  <div class="card-body">
    <p class="card-title text-base">${ref.title}</p>
    <p class="font-light text-sm">${
      ref.description?.length && ref.description?.length > 50
        ? `${ref.description.slice(0, 50)}...`
        : ref.description
    }.</p>
  </div>
</a>`);
}
